import { render, staticRenderFns } from "./DateCalculation.vue?vue&type=template&id=d64ecfea&"
import script from "./DateCalculation.vue?vue&type=script&lang=js&"
export * from "./DateCalculation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports